import React from 'react';
import { Resource } from './styled';
import { IShare, IResource } from '../../../types';

interface IProps {
  share: IShare;
  resources: IResource[];
}

const PolicyShare: React.FC<IProps> = ({ share, resources }) => {
  const actualWeight = share.weight / 100;
  const backup = share.resources.slice(1).map((rid) => (
    <Resource key={rid} data-id={rid}>
      {resources.filter((r) => r.id === rid)[0].name}
    </Resource>
  ));
  const primary = (
    <Resource key={share.resources[0]} data-id={share.resources[0]}>
      {resources.filter((r) => r.id === share.resources[0])[0].name}
    </Resource>
  );

  return (
    <tr>
      <td>{actualWeight}%</td>
      <td>{primary}</td>
      <td>{backup}</td>
    </tr>
  );
};

export default PolicyShare;
